const $ = require("jquery");
import "../css/common.scss";
import BrandLogo from "../assets/images/icon-navbar-logo-normal.svg"
import HoverBrandLogo from "../assets/images/icon-navbar-logo-hover.svg"
import Vue from 'vue'
import NavMenu from "../components/nav-menu.vue"
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

$(document).ready(function(){
  $("#brand-logo img").hover(
    function() {
      $(this).attr("src", HoverBrandLogo)
    },
    function(){
      $(this).attr("src", BrandLogo)
  })

  $(window).scroll(function(){
    const top = $(window).scrollTop()

    if(top > 0)
      $("#header-navbar").addClass("scrolled")
    else
    $("#header-navbar").removeClass("scrolled")
  })

  new Vue({
    el: document.getElementById("menu-toggler"),
    render: (h) => h(NavMenu)
  }).$mount()
});
